import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, first } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { ResumenVerificacionViaje } from "./resumen";
import { ListasVerificacion } from "./listas";

export interface Props {
    model: models.VerificacionViajeZEDto;
    viaje: models.ViajeZEDto;
}

const VerificadoButton = kea.defaultProps(kea.Button, { children: "Finalizar viaje", style: "success", iconClass: fa("check") });
const CrearGuiasAcuseButton = kea.defaultProps(kea.Button, { children: "Crear guias de acuse" });

export class VerificarViajeForm extends React.PureComponent<Props> {
    onVerificar = async () => {
        if (await kea.yesno("Verificar y finalizar viaje", "¿Marcar este viaje como verificado y finalizado?")) {
            await resources.ViajeZE.FinalizarViaje(this.props.viaje.IdRegistro);
            await kea.message("Viaje finalizado", "Se finalizó el viaje correctamente", "success");
        }
    }

    onCrearAcuses = async () => {
        if(await kea.yesno("¿Crear guias de acuse para las guias entregadas en este viaje?")) {
            
            const acuses = await resources.ViajeZE.CrearGuiasAcuse(this.props.viaje.IdRegistro);
            
            await kea.message("Guias de acuse documentadas",  "Se creación " + acuses + " guias de acuse", "success");
        }
    }

    render() {
        return (
            <div>
                <kea.Title titulo="Verificar viaje de ZE" onRegresar={() => history.go("../")} >
                    {this.props.viaje.Status == models.StatusViajeZE.PendienteVerificacion && <VerificadoButton onClick={this.onVerificar} />}
                    {this.props.viaje.Status == models.StatusViajeZE.Finalizado && <CrearGuiasAcuseButton onClick={this.onCrearAcuses} />}
                </kea.Title>

                <ResumenVerificacionViaje {... this.props} />
                <ListasVerificacion {...this.props} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajesZE/verificar/form.tsx